import { DocumentType } from '@prisma/client';
import z from 'zod';

// A blank field would otherwise coerce to 0 and silently become a valid number
export const requiredNumberSchema = z.preprocess(
  (value) => (value === '' || value === null ? undefined : value),
  z.coerce.number({ required_error: 'Required', invalid_type_error: 'Required' }),
);

export const documentSchema = z.object({
  original_filename: z.string().optional(),
  document_type: z
    .nativeEnum(DocumentType, {
      invalid_type_error: 'Invalid Document Type',
    })
    .optional(),
  request_id: z.number().nullish(),
});
